export const PROGRAM_LIST_TABS = {
    PROGRAMS: "My programs",
    PREDEFINED: "Predefined"
}

export const DELETED_STATUS_ID = 3

export const PROGRAM_STATUSES = {
    ACTIVE: 1,
    INACTIVE: 2
}

export const PROGRAM_STATUSES_LABELS = {
    [PROGRAM_STATUSES.ACTIVE]: 'Active',
    [PROGRAM_STATUSES.INACTIVE]: 'Inactive'
}
